import React, { useEffect } from 'react';
import { OpeningSection } from '../components/page/sections/OpeningSection';
import { ReferencesSection } from '../components/page/sections/ReferencesSection';
import { CongressSection } from '../components/page/sections/CongressSection';
import { SignalsSection } from '../components/page/sections/SignalsSection';
import { CompoundSection } from '../components/page/sections/CompoundSection';
import { OngoingSection } from '../components/page/sections/OngoingSection';
import { ChallengeSection } from '../components/page/sections/ChallengeSection';
import { JourneySection } from '../components/page/sections/JourneySection';
import { WebsiteSection } from '../components/page/sections/WebsiteSection';
import { ChannelsSection } from '../components/page/sections/ChannelsSection';
import { UseCasesSection } from '../components/page/sections/UseCasesSection';
import { StationSection } from '../components/page/sections/StationSection';
import { PageNav } from '../components/page/PageNav';
import { CongressShortcut } from '../components/page/CongressShortcut';
import { BookMeetingButton } from '../components/page/BookMeetingButton';
import { useActiveSection } from '../hooks/useActiveSection';
import { deckPages } from '../data/deck';

/** REKOVELLE × Snakker — the IVF Pulse proposal first, broader capabilities after. */
export function Presentation() {
  const active = useActiveSection(deckPages.map(page => page.id));

  // Honour deep links like /#signals once the sections have rendered.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        block: 'start'
      });
    }, 80);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-[var(--surface)]" data-id="element-911" data-mp="3lvxy9vi9tbex">
      {/* The story */}
      <OpeningSection data-id="element-912" data-mp="3lxsmpjsr3lnr" />
      <ReferencesSection data-id="element-913" data-mp="3quizny99e14y" />
      <CongressSection data-id="element-914" data-mp="3qtzjon365mtk" />
      <OngoingSection data-id="element-915" data-mp="3qvauv7yy1wup" />
      <SignalsSection data-id="element-916" data-mp="3qwvhmbf0obi0" />
      <CompoundSection data-id="element-917" data-mp="3ittfhooxx992" />

      {/* Optional: explore more Snakker capabilities */}
      <ChallengeSection data-id="element-918" data-mp="3ivwegy82mcpx" />
      <JourneySection data-id="element-919" data-mp="3eszqst3obqf4" />
      <WebsiteSection data-id="element-920" data-mp="3ett3eapbda56" />
      <ChannelsSection data-id="element-921" data-mp="3euavqw8uv47t" />
      <UseCasesSection data-id="element-922" data-mp="3ss98jx7j2sl7" />
      <StationSection data-id="element-923" data-mp="3sssj2suumep7" />

      <PageNav active={active} data-id="element-924" data-mp="3st25y7klk5qo" />
      <CongressShortcut hidden={active === 'congress'} data-id="element-925" data-mp="3sq6cavfs8381" />
      <BookMeetingButton data-id="element-926" data-mp="3ns4ojx7evfq8" />
    </div>;
}